export default __webpack_public_path__ + "static/media/changetip.eddf7750.svg";